<template>
  <div v-show='show' ref='recaptcha'/>
</template>

<script>
export default {
  name: "UiRecaptcha",
  data() {
    return {
      recaptcha: null
    }
  },
  props: {
    siteKey: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: "normal"
    },
    theme: {
      type: String,
      required: false,
      default: "light"
    },
    show: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  emits: {
    verify: (response) => {
      return !!response;
    },
    expire: null,
    fail: null
  },
  methods: {
    renderRecaptcha() {
      // eslint-disable-next-line no-undef
      this.recaptcha = grecaptcha.render(this.$refs.recaptcha, {
        'sitekey': this.siteKey,
        'theme': this.theme,
        'size': this.size,
        'tabindex': this.tabindex,
        'callback': (response) => this.$emit("verify", response),
        'expired-callback': () => this.$emit("expire"),
        'error-callback': () => this.$emit("fail")
      });
    },
    reset() {
      // eslint-disable-next-line no-undef
      grecaptcha.reset(this.recaptcha);
    }
  },
  mounted() {
    if (!window.grecaptcha) {
      new Promise((resolve) => {
        window.recaptchaReady = function () {
          resolve();
        };

        const doc = window.document;
        const scriptId = "recaptcha-script";
       /* if (doc.getElementById(scriptId) === null){

        } */
        const scriptTag = doc.createElement("script");
        scriptTag.id = scriptId;
        scriptTag.setAttribute("src", "https://www.google.com/recaptcha/api.js?onload=recaptchaReady&render=explicit");
        doc.head.appendChild(scriptTag);
      }).then(() => {
        this.renderRecaptcha();
      });
    } else {
      this.renderRecaptcha();
    }
  }
}
</script>